// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-area';

export const Component = () => (
  <>
    <path
      fill='currentColor'
      d='M.576 12.96v-1.656L6.624 8.28c.432-.216 1.008-.288 1.512-.216l3.168.72c.72.144 1.44 0 2.016-.504l4.176-3.744v12.888H.576V.576'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M.576 12.96v-1.656L6.624 8.28c.432-.216 1.008-.288 1.512-.216l3.168.72c.72.144 1.44 0 2.016-.504l4.176-3.744v12.888H.576V.576'
    />
  </>
);

export const viewBox = '0 0 18 18';
